module.exports = __webpack_public_path__ + "static/media/microphone-alt-slash.c011ef97.svg";